<template>
  <div class="positive" :class="{'visa': isVisaTransaction}">
    <div class="visa-video" :aria-label="$t('confirmation.positive.visaVideo')" v-if="isVisaTransaction">
      <video ref="visaVideo" playsinline>
        <source src="/web/video/visa_small.mp4" type="video/mp4" />
      </video>
    </div>
    <h1 class="normal" id="page-title-for-sr" aria-describedby="payment-section-summary">
      <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
      <span aria-live="assertive" role="status" v-html="$t('confirmation.positive.header')"></span>
    </h1>
    <p :class="{'visa-text': isVisaTransaction}" v-html="$t('confirmation.positive.description')"></p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CARD_ISSUERS } from '@/base/const/cards.const'

export default {
  name: 'ConfirmationPositive',
  computed: {
    ...mapState({
      isVisaTransaction: state => state.confirmation.data?.transaction.cardInformation?.issuer === CARD_ISSUERS.visa
    })
  },
  mounted () {
    if (this.isVisaTransaction) {
      const video = this.$refs.visaVideo
      video.play()
        .catch(() => {
          video.muted = true
          video.play()
        })
    }
  }
}
</script>
